import * as React from 'react'

interface Props {
    thumnailUrl: string
    videoUrl: string
}

interface State {
    isOpen: boolean
}

export class VideoAnswer extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            isOpen: false,
        }
    }

    private openModal = () => {
        this.setState({
            isOpen: true,
        })
    }

    private closeModal = () => {
        this.setState({
            isOpen: false,
        })
    }

    public render = () => {
        return (
            <>
                <div className="AppCore__report__VideoAnswer">
                    <zaptic-annotated-image
                        key={this.props.videoUrl}
                        class="AppCore__report__VideoAnswer__Thumbnail"
                        src={this.props.thumnailUrl}
                    />
                    <div className="AppCore__report__VideoAnswer__PlayOverlay" onClick={this.openModal}>
                        <zaptic-icon icon-name="play" />
                    </div>
                </div>
                {this.state.isOpen && (
                    <zaptic-modal>
                        <div className="AppCore__report__VideoAnswer__ModalContent">
                            <div className="AppCore__report__VideoAnswer__CloseButtonWrapper">
                                <zaptic-button type="transparent" onClick={this.closeModal} size="large">
                                    <zaptic-icon
                                        class="AppCore__report__VideoAnswer__CloseButton"
                                        icon-name="close-cross"
                                    />
                                </zaptic-button>
                            </div>
                            <video
                                className="AppCore__report__VideoAnswer__Video"
                                preload="auto"
                                controls
                                src={this.props.videoUrl}
                            />
                        </div>
                    </zaptic-modal>
                )}
            </>
        )
    }
}
